/**
 * @desc 订单模块
 */
import { orderAxios, orderAxiosDirect, baseAxiosDirect } from '../httpInstance';
// 争议原因
export function getDisputeReason(payload) {
    return orderAxios({
        method: 'GET',
        url: 'disputeReason',
        params: payload,
    });
}
// 查看争议原因
export function getCheckDisputeReason(payload) {
    return orderAxios({
        method: 'GET',
        url: 'checkDisputeReason',
        params: payload,
    });
}
// 争议处理详情
export function getDisputeOptionDetail(payload) {
    return orderAxios({
        method: 'GET',
        url: 'dealDetail',
        params: payload,
    });
}
// daYuDisputeManage
/*
*争议管理--增加大域争议管理弹框
*/
export function daYuDisputeManage(payload) {
    return orderAxios({
        method: 'GET',
        url: 'daYuDisputeManage',
        params: payload,
    });
}
// 订单待付款车辆--大域争议
export function getDealPayTransfer(payload) {
    return orderAxios({
        method: 'POST',
        url: 'getDealPayTransfer',
        params: payload,
    });
}
// confirmGiveCar
/**
 * 卖方交车
 */
export function confirmGiveCar(payload) {
    return orderAxios({
        method: 'POST',
        url: 'confirmGiveCar',
        params: payload,
    });
}
/**
 * 订单列表（通用）
 */
export function OrderManageData(payload) {
    return orderAxios({
        method: 'POST',
        url: 'getOrderTradeFailList',
        params: payload,
    });
}
/**
 * 待买家签署合同订单列表
 */
export function getWaitSignList(data) {
    return orderAxios({
        method: 'POST',
        url: 'getWaitSignList',
        data,
    });
}
/**
 * dealTransDetail争议处理-待处理争议
 * @param payload
 */
export function dealTransDetail(payload) {
    return orderAxios({
        method: 'POST',
        url: 'dealTransDetail',
        params: payload,
    });
}
// 订单全部买家待付款和已付款页面数据
export function getOrderAll(payload) {
    return orderAxios({
        method: 'POST',
        url: 'getOrderAll',
        params: payload,
    });
}
// 订单待付款页面数据
export function getOrderNoPay(payload) {
    return orderAxios({
        method: 'POST',
        url: 'getOrderNoPay',
        params: payload,
    });
}
// 订单已付款页面数据
export function getOrderTBRViewList(payload) {
    return orderAxios({
        method: 'POST',
        url: 'getOrderTBRViewList',
        params: payload,
    });
}
// 订单-财务卖家打款-全部数据
export function getSellerPendingAllList(payload) {
    return orderAxios({
        method: 'POST',
        url: 'getSellerPendingAllList',
        data: payload,
    });
}
// 订单待确认页面数据
export function getOrderTBCViewList(payload) {
    return orderAxios({
        method: 'POST',
        url: 'getOrderTBCViewList',
        data: payload,
    });
}
// 订单已驳回页面数据
export function getOrderTradeFailViewList(payload) {
    return orderAxios({
        method: 'POST',
        url: 'getOrderTradeFailViewList',
        data: payload,
    });
}
// 订单已通过页面数据
export function getOrderSuccessView(payload) {
    return orderAxios({
        method: 'POST',
        url: 'getOrderSuccessView',
        data: payload,
    });
}
// 查看合同信息
export function querySignedContract(payload) {
    return orderAxios({
        method: 'GET',
        url: 'querySignedContract',
        params: payload,
    });
}
// 查看合同确认信息（未生成，未签署，待买方确认状态）
export function queryContractConfirmInfo(payload) {
    return orderAxios({
        method: 'GET',
        url: 'queryContractConfirmInfo',
        params: payload,
    });
}
// 提交买家付款确认
export function buyerRecConfirm(payload) {
    return orderAxios({
        method: 'POST',
        url: 'buyerRecConfirm',
        params: payload,
    });
}
// 提交驳回向卖家付款
export function sellerPayReject(payload) {
    return orderAxios({
        method: 'GET',
        url: 'sellerPayReject',
        params: payload,
    });
}
// 提交向卖家付款确认
export function sellerPayConfirm(payload) {
    return orderAxios({
        method: 'POST',
        url: 'sellerPayConfirm',
        params: payload,
    });
}
// 提交向卖家付款确认（分批通过并打款）
export function sellerPayment(payload) {
    return orderAxios({
        method: 'POST',
        url: 'sellerPayment',
        params: payload,
    });
}
// 财务-卖家付款-批量通过并打款金额
export function sellerBatchMoney(payload) {
    return orderAxios({
        method: 'POST',
        url: 'sellerBatchMoney',
        data: payload,
    });
}
// 财务-卖家付款-批量通过并打款确认
export function sellerBatchConfirm(payload) {
    return orderAxios({
        method: 'POST',
        url: 'sellerBatchConfirm',
        data: payload,
    });
}
/**
 * 系统管理-争议子类型
 */
// 获取争议发起方
export function getDisputeSources() {
    return orderAxios({
        method: 'get',
        url: 'getDisputeSources',
    });
}
// 分页获取争议子类型列表
export function findByPage(payload) {
    return orderAxios({
        method: 'post',
        url: 'findByPage',
        params: { query: payload },
    });
}
// 根据争议发起方编码获取争议类型列表
export function getTypesBySourceCoce(payload) {
    return orderAxios({
        method: 'get',
        url: 'getTypesBySourceCoce',
        params: payload,
    });
}
// 保存争议子类型
export function saveDisputeType(payload) {
    return orderAxios({
        method: 'post',
        url: 'saveDisputeType',
        params: { query: payload },
    });
}
// 删除争议子类型
export function deleteById(payload) {
    return orderAxios({
        method: 'get',
        url: 'deleteById',
        params: payload,
    });
}
// 订单财务首页页面数据视图调用接口
export function getOrderPendingViewList(payload) {
    return orderAxios({
        method: 'POST',
        url: 'getOrderPendingViewList',
        params: payload,
    });
}
// 查看过户信息
export function queryTransferInfo(payload) {
    return orderAxios({
        method: 'GET',
        url: 'queryTransferInfo',
        params: payload,
    });
}
// submitModificationResult
// 提交修改过的过户手续资料
export function submitModificationResult(payload) {
    return orderAxios({
        method: 'POST',
        url: 'submitModificationResult',
        data: payload,
    });
}
/**
 * 争议列表
 * POST /dispute/disputeManagerApi/getDisputeListPage.json
 */
export function getDisputeListPage(payload) {
    return orderAxios({
        method: 'POST',
        url: 'getDisputeListPage',
        data: payload,
    });
}
// 获取合同二维码
export function getSignQRCode(payload) {
    return orderAxios({
        method: 'GET',
        url: 'getSignQRCode',
        params: payload,
    });
}
// 导出
export const globalExport = (params) => {
    return orderAxiosDirect({
        url: 'orderExport',
        method: 'POST',
        responseType: 'blob',
        data: params,
    });
};
// 撮合成交
export const brokeredDeal = (params) => {
    return orderAxios({
        url: 'brokeredDeal',
        method: 'POST',
        params,
    });
};
// 交易成功列表
export function TradeSuccessCarList(payload) {
    return orderAxios({
        method: 'POST',
        url: 'TradeSuccessCarList',
        params: payload,
    });
}
// 其他费用接口
export function applicationSellerPay(payload) {
    return orderAxios({
        method: 'POST',
        url: 'applicationSellerPay',
        data: payload,
    });
}
// 申请向卖家付款
export function TransferOtherFeel(payload) {
    return orderAxios({
        method: 'GET',
        url: 'TransferOtherFeel',
        params: payload,
    });
}
export function comfirmTransferCar(payload) {
    return orderAxios({
        method: 'GET',
        url: 'confirmTransfer',
        params: payload,
    });
}
// desc订单待过户车辆列表
export function WaitTransferCarList(payload) {
    return orderAxios({
        method: 'POST',
        url: 'WaitTransferCarList',
        params: payload,
    });
}
/**
 * 获取上传手续图片模板
 */
export function getUploadPicTempl(payload) {
    return orderAxios({
        method: 'get',
        url: 'getUploadPicTempl',
        params: payload,
    });
}
/**
 * 待付款车辆
 */
export function getWaitPayCar(payload) {
    return orderAxios({
        method: 'POST',
        url: 'getWaitPayCarList',
        data: payload,
    });
}
// 申请财务收款
export function getApplyPayMoney(payload) {
    return orderAxios({
        method: 'get',
        url: 'getApplyPayMoney',
        params: payload,
    });
}
/**
 * 保存过户信息
 */
export function saveTransInfo(payload) {
    return orderAxios({
        method: 'POST',
        url: 'saveTransInfo',
        data: payload,
    });
}
/**
 * 获取发起方
 */
export function getOpenType() {
    return orderAxios({
        method: 'get',
        url: 'getOpenType',
    });
}
/**
 * 获取争议类型
 */
export function getDisputeType(payload) {
    return orderAxios({
        method: 'get',
        url: 'getDisputeType',
        params: payload,
    });
}
/**
 * 获取争议子类型
 */
export function getDisputeChildType(payload) {
    return orderAxios({
        method: 'post',
        url: 'getDisputeChildType',
        params: { query: payload },
    });
}
/**
 * 提价申请争议 submitDisputeApply JSON
 */
export function submitDisputeApply(payload) {
    return orderAxios({
        method: 'POST',
        url: 'submitDisputeApply',
        data: payload,
    });
}
/**
 * 流拍 orderFailure
 */
export function orderFailure(payload) {
    return orderAxios({
        method: 'POST',
        url: 'orderFailure',
        params: payload,
    });
}
/**
 * 提交 争议处理
 * 买方违约 buyerDefault
 * 卖方违约 sellerDefault
 * 交易继续 tradeContinue
 * 流   拍 disputeTradeFailure
 * @param {string} apiUrl
 * @param {object} payload
 * @returns {AxiosPromise}
 */
export function submitDealDispute(apiUrl, payload) {
    return orderAxios({
        method: 'POST',
        url: apiUrl,
        params: payload,
    });
}
// 大域争议弹框daYuDisputeReason
export function getDaYuDisputeListPage(payload) {
    return orderAxios({
        method: 'POST',
        url: 'daYuDisputeReason',
        data: payload,
    });
}
/**
 * 争议处理-买方违约
 */
export function buyerDefault(payload) {
    return orderAxios({
        method: 'POST',
        url: 'buyerDefault',
        params: payload,
    });
}
/**
 * 争议处理-卖方违约
 */
export function sellerDefault(payload) {
    return orderAxios({
        method: 'POST',
        url: 'sellerDefault',
        params: payload,
    });
}
/**
 * 争议处理-交易继续
 */
export function tradeContinue(payload) {
    return orderAxios({
        method: 'POST',
        url: 'tradeContinue',
        params: payload,
    });
}
/**
 * 争议处理-流拍
 */
export function disputeTradeFailure(payload) {
    return orderAxios({
        method: 'POST',
        url: 'disputeTradeFailure',
        params: payload,
    });
}
// buyTransData
/**
 *买方同意和驳回按钮
 */
export function buyTransData(payload) {
    return orderAxios({
        method: 'POST',
        url: 'buyTransData',
        data: payload,
    });
}
/**
 * 争议处理-买卖家违约-获取用户可用保证金
 */
export function getUserDepositBalance(payload) {
    return orderAxios({
        method: 'get',
        url: 'getUserDepositBalance',
        params: payload,
    });
}
/**
 * 上传图片
 */
// desc 文件上传
export function uploadImage(payload) {
    return baseAxiosDirect({
        method: 'POST',
        url: 'orderUploadImage',
        data: payload,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}
/**
 * 争议处理-买卖家违约-获取用户可用保证金
 */
export function getOrderPaymentAmount(payload) {
    return orderAxios({
        method: 'get',
        url: 'getOrderPaymentAmount',
        params: payload,
    });
}
/**
 * 待买家签署合同
 */
export function skipSignContract(payload) {
    return orderAxios({
        method: 'get',
        url: 'skipSignContract',
        params: payload,
    });
}
// 中标车辆table
export function winBiddingCarTable(payload) {
    return orderAxios({
        method: 'POST',
        url: 'winBiddingCarTable',
        data: payload,
    });
}
// 撮合成交
export function getMatchUp(payload) {
    return orderAxios({
        method: 'POST',
        url: 'getMatchUp',
        data: payload,
    });
}
// 正常成交
export function normalDeal(payload) {
    return orderAxios({
        method: 'POST',
        url: 'normalDeal',
        data: payload,
    });
}
// 正常成交
export function breakContract(payload) {
    return orderAxios({
        method: 'POST',
        url: 'breakContract',
        data: payload,
    });
}
// 处理违约
export function dealBreakContract(payload) {
    return orderAxios({
        method: 'POST',
        url: 'dealBreakContract',
        data: payload,
    });
}
// 获取订单各个环节数量信息接口
export function getOrderCountInfoApi(payload) {
    return orderAxios({
        method: 'POST',
        url: 'getOrderCountInfoApi',
        // url:'http://auctioncenter-order.souche.dev.dasouche-inc.net/orderview/carOrderViewApi/getOrderCountInfoApi.json',
        data: payload,
    });
}
// 获取采购信息
export function getProcurementInfo(data) {
    return orderAxios({
        method: 'POST',
        url: 'getProcurementInfo',
        data,
        ['hideLoading']: true,
    });
}
